import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../../components/Layout';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { Send, Mail, Users, Building2, Bell, RefreshCw, Clock, Loader2, CheckCircle } from 'lucide-react';

const TEMPLATES = [
  { label:'🆕 Nova funcionalidade', titulo:'🚀 Nova funcionalidade no AcreJob!', corpo:`<p>Olá, <strong>{nome}</strong>!</p><p>Temos novidades incríveis para você no <strong>AcreJob</strong>!</p><p>[Descreva a novidade aqui]</p><div style="text-align:center;margin:24px 0;"><a href="https://acrejob.com.br" style="background:#1a6b45;color:#fff;padding:12px 28px;border-radius:8px;text-decoration:none;font-weight:bold;">Acessar AcreJob →</a></div>` },
  { label:'📢 Comunicado geral',    titulo:'📢 Comunicado — AcreJob',            corpo:`<p>Olá, <strong>{nome}</strong>!</p><p>Gostaríamos de compartilhar uma informação importante.</p><p>[Escreva seu comunicado aqui]</p>` },
  { label:'💼 Vagas para candidatos',titulo:'💼 Novas vagas disponíveis para você!',corpo:`<p>Olá, <strong>{nome}</strong>!</p><p>Há novas vagas compatíveis com seu perfil no <strong>AcreJob</strong>!</p><div style="text-align:center;margin:24px 0;"><a href="https://acrejob.com.br/candidato/matches" style="background:#1a6b45;color:#fff;padding:12px 28px;border-radius:8px;text-decoration:none;font-weight:bold;">Ver Vagas para Mim →</a></div>` },
  { label:'🏢 Para empresas',       titulo:'🎯 Encontre talentos agora no AcreJob!', corpo:`<p>Olá, <strong>{nome}</strong>!</p><p>Sua empresa pode encontrar os melhores talentos do Acre com nosso algoritmo de match por IA.</p><div style="text-align:center;margin:24px 0;"><a href="https://acrejob.com.br/empresa" style="background:#1a6b45;color:#fff;padding:12px 28px;border-radius:8px;text-decoration:none;font-weight:bold;">Publicar Vagas →</a></div>` },
];

export default function AdminNotificacoes() {
  const [aba,          setAba]          = useState('email_diario');
  const [titulo,       setTitulo]       = useState('');
  const [corpo,        setCorpo]        = useState('');
  const [destinatarios,setDestinatarios]= useState('todos');
  const [contagem,     setContagem]     = useState(null);
  const [enviando,        setEnviando]        = useState(false);
  const [enviandoPerfil,  setEnviandoPerfil]  = useState(false);
  const [tipoPerfil,      setTipoPerfil]      = useState('todos');
  const [enviandoDia,  setEnviandoDia]  = useState(false);
  const [historico,    setHistorico]    = useState([]);
  const [loadHist,     setLoadHist]     = useState(true);

  const carregarContagem = useCallback(async () => {
    try {
      const { data } = await api.get(`/admin/notificacoes/destinatarios?tipo=${destinatarios}`);
      setContagem(data);
    } catch {}
  }, [destinatarios]);

  useEffect(() => { carregarContagem(); }, [carregarContagem]);

  useEffect(() => {
    api.get('/admin/notificacoes/historico').then(r => setHistorico(r.data||[])).catch(()=>{}).finally(()=>setLoadHist(false));
  }, []);

  const dispararEmailCompletarPerfil = async () => {
    if (!window.confirm(`Enviar email "Completar Perfil" para todos os ${tipoPerfil === 'todos' ? 'usuários' : tipoPerfil}?`)) return;
    setEnviandoPerfil(true);
    try {
      const { data } = await api.post('/admin/email-completar-perfil', { tipo: tipoPerfil });
      toast.success(data.mensagem || `Enviando para ${data.total} usuários!`);
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao enviar.');
    }
    setEnviandoPerfil(false);
  };

  const dispararEmailDiario = async () => {
    setEnviandoDia(true);
    try {
      const { data } = await api.post('/admin/email-diario');
      toast.success(data.mensagem || 'E-mails sendo enviados!');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao disparar e-mails.');
    }
    setEnviandoDia(false);
  };

  const enviar = async () => {
    if (!titulo.trim() || !corpo.trim()) return toast.error('Preencha título e conteúdo.');
    if (!window.confirm(`Enviar para ${contagem?.total || '?'} usuários?`)) return;
    setEnviando(true);
    try {
      const { data } = await api.post('/admin/notificacoes/enviar', { titulo, corpo, destinatarios });
      toast.success(data.mensagem);
      setTitulo(''); setCorpo('');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao enviar.');
    }
    setEnviando(false);
  };

  return (
    <Layout title="📨 Notificações por E-mail" subtitle="Comunicação com candidatos e empresas">

      {/* Abas */}
      <div className="flex gap-1 mb-6 border-b border-gray-200">
        {[
          { id:'email_diario', label:'📅 E-mail Diário' },
          { id:'campanha',     label:'✍️ Envio Manual' },
          { id:'historico',    label:`📋 Histórico (${historico.length})` },
        ].map(a => (
          <button key={a.id} onClick={() => setAba(a.id)}
            className={`px-4 py-2.5 text-sm font-semibold border-b-2 transition-colors ${
              aba === a.id ? 'border-acre-green text-acre-green' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>
            {a.label}
          </button>
        ))}
      </div>

      {/* ── E-MAIL DIÁRIO ── */}
      {aba === 'email_diario' && (
        <div className="max-w-lg space-y-5">
          <div className="card p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-acre-green/10 rounded-xl flex items-center justify-center">
                <Bell size={22} className="text-acre-green"/>
              </div>
              <div>
                <p className="font-sora font-bold text-acre-dark">E-mail Diário de Vagas</p>
                <p className="text-xs text-gray-400">Notifica todos os candidatos sobre vagas disponíveis</p>
              </div>
            </div>
            <div className="bg-acre-light border border-acre-green/20 rounded-xl p-4 mb-5 text-sm text-gray-600 space-y-2">
              <p>✅ Envia para todos os candidatos cadastrados</p>
              <p>✅ Mostra as 3 vagas mais recentes do dia</p>
              <p>✅ Link direto para as vagas compatíveis</p>
              <p>✅ Processo em background (não trava o sistema)</p>
            </div>
            <button onClick={dispararEmailDiario} disabled={enviandoDia}
              className="btn-primary w-full justify-center py-3.5 flex items-center gap-2 text-base disabled:opacity-60">
              {enviandoDia ? <><Loader2 size={18} className="animate-spin"/> Disparando...</>
                           : <><Send size={18}/> Disparar E-mail Diário Agora</>}
            </button>
            <p className="text-xs text-gray-400 text-center mt-3">
              Também configurado para rodar automaticamente todos os dias às 08h00 (horário de Brasília)
            </p>
          </div>

          <div className="card p-4 bg-blue-50 border border-blue-100">
            <p className="text-xs font-semibold text-blue-700 mb-1">🤖 Automação diária</p>
            <p className="text-xs text-blue-600">
              O sistema envia automaticamente às 08h00. Use o botão acima para disparar manualmente a qualquer hora.
            </p>
          </div>

          {/* E-mail Completar Perfil */}
          <div className="card p-6 border-2 border-acre-gold/30 bg-acre-gold/5">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-acre-gold/10 rounded-xl flex items-center justify-center">
                <Users size={22} className="text-acre-gold"/>
              </div>
              <div>
                <p className="font-sora font-bold text-acre-dark">E-mail: Completar Perfil</p>
                <p className="text-xs text-gray-400">Pede aos usuários que entrem e completem o perfil</p>
              </div>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl p-4 mb-4 text-sm text-gray-600 space-y-1.5">
              <p>✅ E-mail personalizado por tipo (candidato/empresa)</p>
              <p>✅ Candidato: convida para criar perfil com Mikhal IA</p>
              <p>✅ Empresa: convida para publicar vagas e ver matches</p>
              <p>✅ Remetente: <strong>AcreJob Plataforma Digital</strong></p>
            </div>
            {/* Filtro por tipo */}
            <div className="flex gap-2 mb-4">
              {[
                { v:'todos',      l:'👥 Todos' },
                { v:'candidatos', l:'👤 Candidatos' },
                { v:'empresas',   l:'🏢 Empresas' },
              ].map(op => (
                <button key={op.v} onClick={() => setTipoPerfil(op.v)}
                  className={`flex-1 py-2 text-xs font-semibold rounded-xl border-2 transition-all ${
                    tipoPerfil === op.v ? 'border-acre-gold bg-acre-gold/10 text-acre-dark' : 'border-gray-200 text-gray-500 hover:border-acre-gold/50'}`}>
                  {op.l}
                </button>
              ))}
            </div>
            <button onClick={dispararEmailCompletarPerfil} disabled={enviandoPerfil}
              className="w-full py-3.5 bg-acre-gold hover:bg-acre-gold/90 text-white font-sora font-bold rounded-xl flex items-center justify-center gap-2 transition-colors disabled:opacity-60 text-sm">
              {enviandoPerfil
                ? <><Loader2 size={16} className="animate-spin"/> Enviando...</>
                : <><Send size={16}/> Enviar Agora para {tipoPerfil === 'todos' ? 'Todos' : tipoPerfil === 'candidatos' ? 'Candidatos' : 'Empresas'}</>}
            </button>
          </div>
        </div>
      )}

      {/* ── CAMPANHA MANUAL ── */}
      {aba === 'campanha' && (
        <div className="grid lg:grid-cols-3 gap-5">
          <div className="lg:col-span-2 space-y-4">
            {/* Templates */}
            <div className="card p-4">
              <p className="text-sm font-semibold text-gray-600 mb-2">Templates prontos:</p>
              <div className="grid grid-cols-2 gap-2">
                {TEMPLATES.map(t => (
                  <button key={t.label} onClick={() => { setTitulo(t.titulo); setCorpo(t.corpo); }}
                    className="text-left text-xs p-2.5 border border-gray-200 rounded-xl hover:border-acre-green hover:bg-acre-light transition-all">
                    {t.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="card p-5 space-y-4">
              <div>
                <label className="label">Assunto do e-mail *</label>
                <input className="input" value={titulo} onChange={e => setTitulo(e.target.value)}
                  placeholder="Ex: 🚀 Nova funcionalidade no AcreJob!"/>
              </div>
              <div>
                <label className="label">Conteúdo * <span className="text-xs text-gray-400 font-normal">(HTML suportado · {'{nome}'} personaliza)</span></label>
                <textarea className="input font-mono text-xs min-h-48 resize-none leading-relaxed"
                  value={corpo} onChange={e => setCorpo(e.target.value)}
                  placeholder="<p>Olá, <strong>{nome}</strong>!</p>&#10;<p>Seu conteúdo aqui...</p>"/>
              </div>
            </div>

            {corpo && (
              <div className="card p-4">
                <p className="text-xs font-bold text-gray-500 mb-2">👁️ Pré-visualização</p>
                <div className="border rounded-xl overflow-hidden">
                  <div className="bg-[#0f2318] px-5 py-3 text-center">
                    <span className="font-bold text-white text-lg">Acre<span className="text-yellow-400">Job</span></span>
                  </div>
                  <div className="h-0.5 bg-[#c8a035]"/>
                  <div className="p-4 text-sm" dangerouslySetInnerHTML={{ __html: corpo.replace(/{nome}/gi,'<em style="color:#1a6b45">João Silva</em>') }}/>
                </div>
              </div>
            )}
          </div>

          <div className="space-y-4">
            <div className="card p-5">
              <p className="font-sora font-bold text-sm text-acre-dark mb-3 flex items-center gap-2"><Users size={14}/> Destinatários</p>
              {[
                { v:'todos',      l:'👥 Todos',          d:'Empresas + candidatos' },
                { v:'candidatos', l:'👤 Candidatos',     d:'Somente candidatos' },
                { v:'empresas',   l:'🏢 Empresas',       d:'Somente empresas' },
              ].map(op => (
                <label key={op.v} className={`flex items-start gap-3 p-3 rounded-xl border-2 cursor-pointer mb-2 last:mb-0 transition-all ${destinatarios===op.v?'border-acre-green bg-acre-light':'border-gray-100'}`}>
                  <input type="radio" name="dest" value={op.v} checked={destinatarios===op.v} onChange={()=>setDestinatarios(op.v)} className="mt-0.5 accent-acre-green"/>
                  <div>
                    <p className={`text-sm font-semibold ${destinatarios===op.v?'text-acre-green':'text-gray-700'}`}>{op.l}</p>
                    <p className="text-xs text-gray-400">{op.d}</p>
                  </div>
                </label>
              ))}
              {contagem && (
                <div className="mt-3 bg-gray-50 rounded-xl p-3 text-center">
                  <p className="font-sora font-black text-2xl text-acre-green">{contagem.total}</p>
                  <p className="text-xs text-gray-400">destinatários</p>
                </div>
              )}
            </div>
            <button onClick={enviar} disabled={enviando||!titulo.trim()||!corpo.trim()}
              className="w-full py-3.5 bg-acre-green hover:bg-acre-mid disabled:bg-gray-300 text-white font-bold rounded-2xl flex items-center justify-center gap-2 transition-colors text-sm disabled:cursor-not-allowed">
              {enviando ? <><Loader2 size={16} className="animate-spin"/> Enviando...</>
                        : <><Send size={16}/> Enviar para {contagem?.total||'...'}</>}
            </button>
          </div>
        </div>
      )}

      {/* ── HISTÓRICO ── */}
      {aba === 'historico' && (
        <div>
          {loadHist ? (
            <div className="flex justify-center py-12"><Loader2 size={24} className="animate-spin text-acre-green"/></div>
          ) : historico.length === 0 ? (
            <div className="card p-12 text-center"><Mail size={32} className="text-gray-200 mx-auto mb-3"/><p className="text-gray-400">Nenhuma notificação enviada ainda.</p></div>
          ) : (
            <div className="space-y-2">
              {historico.map(item => (
                <div key={item.id} className="card p-4 flex items-center gap-3">
                  <CheckCircle size={16} className="text-green-500 flex-shrink-0"/>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-800 truncate">{item.titulo}</p>
                    <p className="text-xs text-gray-400">{item.destinatarios} · {item.total_enviado} enviados · {new Date(item.created_at).toLocaleString('pt-BR',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'})}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </Layout>
  );
}
